import PageContainer from '@/views/base/page.vue'
export default [
  {
    path: '/index',
    component: PageContainer,
    children: [
      {
        path: '/building',
        component: () => import('@/views/building/index.vue'),
        meta: { title: '党建', keepAlive: true, needAuth: false }
      },
      {
        path: '/building/detail',
        component: () => import('@/views/building/content-detail.vue'),
        meta: { title: '资讯详情', keepAlive: false, needAuth: false }
      },
    ]
  }
]
